var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLightBulb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  viewBox: "0 0 17 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#191919"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.75 8a4.75 4.75 0 1 1 8.744 2.571l-.01.017c-.476.738-.8 1.24-.882 1.78l-.082 1.727A2 2 0 0 1 9.523 16H7.477a2 2 0 0 1-1.997-1.905l-.082-1.728c-.082-.539-.406-1.041-.882-1.78l-.01-.016A4.73 4.73 0 0 1 3.75 8M8.5 5.25a2.75 2.75 0 0 0-2.313 4.238l.094.145c.245.377.546.839.775 1.367h2.888c.23-.528.53-.99.775-1.367l.095-.145A2.75 2.75 0 0 0 8.5 5.25M7.477 14l-.047-1h2.14l-.047 1z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 8,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 3,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 3,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 8,
  r: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 4,
  x: 7.5,
  y: 8,
  rx: 1
}))));
export default SvgLightBulb;